<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                            class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>
        <b-row class="d-flex justify-content-between">
            <b-col>
                <b-button
                        id="btnAnterior"
                        class="mr-2"
                        @click="$emit('prevTab')"
                        variant="secondary"
                        style="height: 40px;" >
                    <i class="fa fa-arrow-left"></i> Anterior
                </b-button>
                <CompBotaoExibirOcultarColuna
                        :fields="fields"
                        :showColunms="showColunms"
                        @toggleColuna="toggleColuna"/>
            </b-col>
            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                              :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                              v-if="configTable.perPage != 'Todos'">
                </b-pagination>
            </b-col>
            <b-col class="text-right">
                <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros"
                          style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                    <i class="fas fa-broom"></i> Limpar Filtros
                </b-button>
                <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                               class="col-2" style="height: 40px;"></b-form-select>
                <b-button class="ml-2" id="btnProximaTabela"
                          @click="$emit('nextStep')"
                          :disabled="cdasSelecionadas != null && cdasSelecionadas.length <= 0"
                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-table :items="items"
                :fields="fields"
                striped
                small
                responsive="sm"
                :busy="configTable.load"
                show-empty
                hover
                bordered
                class="mb-0"
                head-variant="light">
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma CDA encontrada.</p>
            </template>
            <template v-slot:head(selecionar)="{ item }">
                <b-form-checkbox v-model="configTable.checkedAll" class="coluna-fixa justify-content-center text-center" @change="toggleAll" />
            </template>
            <template v-slot:cell(selecionar)="{ item }">
                <b-form-checkbox class="coluna-resize mx-auto justify-content-center text-center" style="z-index: 0" :checked="cdasSelecionadas.includes(item)" @change="toggleCheck($event, item)" :disabled="!verificarCdaSelecionavel(item) || verificarCdaJaSelecionada.indexOf(item.codCdaSefa) >= 0" />
            </template>
            <template v-slot:head(1)="{ item }">
                CDA <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroDivida) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA', 'mascara', '', '##########', $event)"></i>
            </template>
            <template v-slot:cell(1)="{ item }">
                <p class="coluna-resize text-center">
                    <a class="link" @click="abrirModalExtratoCda(item.numeroDivida)">
                        {{ item.numeroDivida }}
                    </a>
                </p>
            </template>
            <template v-slot:head(2)="{ item }">
                Tipo Crédito <i class="coluna-fixa filter" :class="!isEmpty(filtros.tipoCredito) || filtros.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Crédito', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(2)="{ item }">
                <p class="coluna-resize">
                    {{ item.tipoCredito }}
                </p>
            </template>
            <template v-slot:head(3)="{ item }">
                Situação <i class="coluna-fixa filter" :class="!isEmpty(filtros.situacao) || filtros.filtrarSituacao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(3)="{ item }">
                <p class="coluna-resize" v-if="item.situacao != null">
                    {{ item.situacao }}
                </p>
                <p class="coluna-resize text-danger" v-if="item.situacao == null">
                    Erro! Repita o processo
                </p>
            </template>
            <template v-slot:head(4)="{ item }">
                Valor Pendente (R$) <i class="coluna-fixa filter" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Pendente (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(4)="{ item }">
                <p class="coluna-resize text-right" v-if="item.valor != null">
                    {{ item.valor | currency }}
                </p>
                <p class="coluna-resize text-right text-danger" v-if="item.valor == null">
                    Erro! Repita o processo
                </p>
            </template>
            <template v-slot:head(5)="{ item }">
                REFIS Ativo <i class="filter" :class="!isEmpty(filtros.refisAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('REFIS Ativo', 'radio', 'N,S', null, $event)"></i>
            </template>
            <template v-slot:cell(5)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.refisAtivo }}
                </p>
            </template>
            <template v-slot:head(6)="{ item }">
                Tabelionato <i class="coluna-fixa filter" :class="!isEmpty(filtros.tabelionato) || filtros.filtrarTabelionato == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tabelionato', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(6)="{ item }">
                <p class="coluna-resize">
                    {{ item.tabelionato }}
                </p>
            </template>
            <template v-slot:head(7)="{ item }">
                Protoc. CRA <i class="coluna-fixa filter" :class="!isEmpty(filtros.protocoloCra) || filtros.filtrarProtocoloCra == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Protoc. CRA', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(7)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.protocolo }}
                </p>
            </template>
            <template v-slot:head(8)="{ item }">
                Data Envio <i class="coluna-fixa filter" :class="!isEmpty(filtros.dataEnvio) || filtros.filtrarDataEnvio == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Envio', 'data', '', null, $event)"></i>
            </template>
            <template v-slot:cell(8)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.dataEnvio }}
                </p>
            </template>
            <template v-slot:head(9)="{ item }">
                Req. de Hono. de Protesto <i class="coluna-fixa filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Req. de Hono. de Protesto', 'texto', '', null, $event)"></i>
            </template>
            <template v-slot:cell(9)="{ item }">
                <p class="coluna-resize text-left" v-for="requisicao in item.listaHonorariosProtesto">
                    <a class="link" @click="abrirModalExtrato(requisicao)" :style="'color: ' + requisicao.cor" id="teste">
                        {{ requisicao.numeroRequisicao }} {{ requisicao.statusRequisicao }}
                    </a>
                </p>
                <p class="coluna-resize text-left" v-if="item.listaHonorariosProtesto != null && item.listaHonorariosProtesto.length <= 0">
                    Não Emitida
                </p>
            </template>
        </b-table>

        <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
            <b-col class="col-md-5">
            </b-col>
            <b-col style="display: flex; justify-content: center;" class="col-md-3">
            </b-col>
            <b-col class="col-md-2 text-right">
                <div data-v-48ccbe7e="" class="input-group input-group-md mb-2">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>Protestos Ativos Sem Carta:&nbsp; </b>
                            {{configTable.perPage != 'Todos' ? configTable.rows : items.length}}
                        </span>
                    </div>
                </div>
            </b-col>
            <b-col class="col-md-2 text-right">
                <div data-v-48ccbe7e="" class="input-group input-group-md mb-2">
                    <div data-v-48ccbe7e="" class="input-group-prepend">
                        <span class="input-group-text">
                            <b>Protestos Selecionados:&nbsp; </b>
                            {{cdasSelecionadas != null ? cdasSelecionadas.length : ''}}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <CompLoading ref="loadingTabela"/>

        <ExtratoHonorariosProtesto
                ref="extratoHonorariosProtesto"
                :loading="this.$refs.loadingTabela"
                @obterHonorariosProtesto="obterHonorariosProtesto"
                @closeModal="(update) => { updated = update; closeModal(); }"
                @openFilterModal="openFilter" />
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import CompLoading from "../../shared/components/CompLoading";
    import ExtratoHonorariosProtesto from "../../shared/components/ExtratoHonorariosProtesto";

    export default {
    props: ['requisicao', 'cdasSelecionadas'],
    components: {ExtratoHonorariosProtesto, CompBotaoExibirOcultarColuna, CompLoading},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.consultar();
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.consultar();
        }
    },
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            filtros: {
                numeroDivida: null,
                filtrarTipoCredito: null,
                tipoCredito: null,
                filtrarSituacao: null,
                situacao: null,
                filtrarValor: null,
                valor: null,
                refisAtivo: null,
                filtrarTabelionato: null,
                tabelionato: null,
                filtrarProtocoloCra: null,
                protocoloCra: null,
                filtrarDataEnvio: null,
                dataEnvio: null,
                filtrarNumeroRequisicao: null,
                numeroRequisicao: null
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                listaValores: []
            },
            fields: [
                {
                    key: "selecionar",
                }
            ],
            items: [],
            configTable: {
                perPage: 100,
                lastPage: null,
                sortField: 'cda.numerodivida',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            currentScroll: null,
            pesquisaInicial: true,
            showColunms: []
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        verificarCdaJaSelecionada() {
            let invalidas = [];
            for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                for(let j = 0; j < this.items.length; j++) {
                    if(this.cdasSelecionadas[i].codCdaSefa != this.items[j].codCdaSefa
                            && this.cdasSelecionadas[i].numeroDivida == this.items[j].numeroDivida) {
                        invalidas.push(this.items[j].codCdaSefa);
                    }
                }
            }
            return invalidas;
        }
    },
    methods: {
        nomeDevedorFormatado() {
            return this.requisicao.devedor.nome +
                (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                    this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                this.requisicao.devedor.documento + ')';
        },
        async obterColunasUsuario() {
            const funcionalidade = 'honorariosProtestoCdaAtiva';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },
        verificarCdaSelecionavel(cda) {
            for(let i = 0;i < cda.listaHonorariosProtesto.length; i++) {
                if(cda.listaHonorariosProtesto[i].statusRequisicao == 'aguardando aprovação'
                    || cda.listaHonorariosProtesto[i].statusRequisicao == 'aguardando validação'
                    || cda.listaHonorariosProtesto[i].statusRequisicao == 'pendente'
                    || cda.listaHonorariosProtesto[i].statusRequisicao == 'em dia'
                    || cda.listaHonorariosProtesto[i].statusRequisicao == 'atrasada'
                    || cda.listaHonorariosProtesto[i].statusRequisicao == 'quitada') {
                    return false;
                }
            }

            if(cda.situacao == null || cda.valor == null) {
                return false;
            }

            return true;
        },
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },
        toggleAll(checked) {
            if(checked) {
                this.items.forEach(el => {
                    if(!this.cdasSelecionadas.includes(el) && this.verificarCdaSelecionavel(el)) {
                        this.cdasSelecionadas.push(el);
                    }
                })
            } else {
                this.items.forEach(el => {
                    if(this.cdasSelecionadas.includes(el)) {
                        const index = this.cdasSelecionadas.indexOf(el);
                        this.cdasSelecionadas.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.cdasSelecionadas.push(item);
            } else {
                const index = this.cdasSelecionadas.indexOf(item);
                this.cdasSelecionadas.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        async consultarComScroll() {
            this.currentScroll = document.documentElement.scrollTop;
            if (this.updated) {
                this.consultar();
            }
        },
        async consultar() {
            let perPageStr = `&perPage=${this.configTable.perPage}`;
            if (this.configTable.perPage === 'Todos') {
                perPageStr = '';
                this.configTable.currentPage = 1;
                this.configTable.rows = 0;
            }

            if(this.requisicao.numeroCda != null && this.requisicao.numeroCda != "") {
                this.filtros.numeroDividaPrincipal = this.requisicao.numeroCda;
            } else {
                this.filtros.documentoDevedor = this.requisicao.devedor.documento;
            }

            this.configTable.load = true;
            axios.post(`${this.urlApi}/v1/honorariosProtesto/consultarCda?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.items = response.data.resultado;

                if(this.pesquisaInicial && this.items.length == 1 && this.verificarCdaSelecionavel(this.items[0])) {
                    this.atribuirSelecionadas(this.items);
                }

                this.pesquisaInicial = false;

                for(var i = 0; i < this.cdasSelecionadas.length; i++) {
                    for (var j = 0; j < this.items.length; j++) {
                        if (this.items[j].codCdaSefa == this.cdasSelecionadas[i].codCdaSefa) {
                            this.cdasSelecionadas[i] = this.items[j];
                        }
                    }
                }
                if (this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows;
                    this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                } else {
                    this.configTable.lastPage = 1;
                }

                if(this.currentScroll != null) {
                    setTimeout(()=>{
                        document.documentElement.scrollTop = this.currentScroll;
                        this.currentScroll = null;
                    }, 100);
                }
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },
        atribuirSelecionadas(cdas) {
            this.$emit('selecionarCdas', cdas);
        },
        limparFiltros() {
            this.filtros = {
                numeroDivida: null,
                filtrarTipoCredito: null,
                tipoCredito: null,
                filtrarSituacao: null,
                situacao: null,
                filtrarValor: null,
                valor: null,
                refisAtivo: null,
                filtrarTabelionato: null,
                tabelionato: null,
                filtrarProtocoloCra: null,
                protocoloCra: null,
                filtrarDataEnvio: null,
                dataEnvio: null,
                filtrarNumeroRequisicao: null,
                numeroRequisicao: null
            };

            this.consultar();
        },
        openFilter(campo, tipo, values, mascara, event) {
            if(document.getElementById('popup').style.display != 'block'
                || this.filtro.campoFiltro != campo) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'CDA') {
                    this.filtro.campoMascara = this.filtros.numeroDivida;
                } else if(this.filtro.campoFiltro == 'Req. de Hono. de Protesto') {
                    this.filtro.filtrarEm = this.filtros.filtrarNumeroRequisicao;
                    this.filtro.campoTexto = this.filtros.numeroRequisicao;
                } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                    this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                    this.filtro.campoTexto = this.filtros.tipoCredito;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtro.filtrarEm = this.filtros.filtrarSituacao;
                    this.filtro.campoTexto = this.filtros.situacao;
                } else if(this.filtro.campoFiltro == 'Tabelionato') {
                    this.filtro.filtrarEm = this.filtros.filtrarTabelionato;
                    this.filtro.campoTexto = this.filtros.tabelionato;
                } else if(this.filtro.campoFiltro == 'Protoc. CRA') {
                    this.filtro.filtrarEm = this.filtros.filtrarProtocoloCra;
                    this.filtro.campoTexto = this.filtros.protocoloCra;
                } else if(this.filtro.campoFiltro == 'Data Envio') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataEnvio;
                    this.filtro.campoData = this.filtros.dataEnvio;
                } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValor;
                    this.filtro.campoTexto = this.filtros.valor;
                } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                    this.filtro.campoRadio = this.filtros.refisAtivo;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$emit('atribuirFiltros', this.filtro);

                this.$emit('openCloseFilterPopup', event);
            } else {
                this.$emit('closeFilterPopup');
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'CDA') {
                this.filtros.numeroDivida = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'Req. de Hono. de Protesto') {
                this.filtros.filtrarNumeroRequisicao = this.filtro.filtrarEm;
                this.filtros.numeroRequisicao = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                this.filtros.tipoCredito = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Situação') {
                this.filtros.filtrarSituacao = this.filtro.filtrarEm;
                this.filtros.situacao = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Tabelionato') {
                this.filtros.filtrarTabelionato = this.filtro.filtrarEm;
                this.filtros.tabelionato = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Protoc. CRA') {
                this.filtros.filtrarProtocoloCra = this.filtro.filtrarEm;
                this.filtros.protocoloCra = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Data Envio') {
                this.filtros.filtrarDataEnvio = this.filtro.filtrarEm;
                this.filtros.dataEnvio = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                this.filtros.filtrarValor = this.filtro.filtrarEm;
                this.filtros.valor = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.filtros.refisAtivo = this.filtro.campoRadio;
            }

            this.configTable.currentPage = 1;

            this.consultar();
        },
        ordenarResultados(order) {
            if(this.filtro.campoFiltro == 'CDA') {
                this.configTable.sortField = 'cda.numerodivida';
            } else if(this.filtro.campoFiltro == 'Req. de Hono. de Protesto') {
                this.configTable.sortField = 'numeroRequisicaoProtesto';
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.configTable.sortField = 'indtipocredito';
            } else if(this.filtro.campoFiltro == 'Situação') {
                this.configTable.sortField = 'situacao';
            } else if(this.filtro.campoFiltro == 'Tabelionato') {
                this.configTable.sortField = 'tabelionato.nome';
            } else if(this.filtro.campoFiltro == 'Protoc. CRA') {
                this.configTable.sortField = 'protesto.protocolo_t32';
            } else if(this.filtro.campoFiltro == 'Data Envio') {
                this.configTable.sortField = 'protesto.dataapt';
            } else if(this.filtro.campoFiltro == 'Valor Pendente (R$)') {
                this.configTable.sortField = 'valor';
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.configTable.sortField = 'indrefis';
            }

            this.configTable.sortOrder = order;

            this.consultar();
        },
        onScroll(e) {
            var thColunas = document.getElementsByClassName("coluna-fixa")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnAnterior").parentElement.parentElement;

            commandLine.style.position = 'sticky';
            commandLine.style.top = '60px';
            commandLine.style.zIndex = 2;
            commandLine.classList.add("background-scroller");

            thColunas.style.position = 'sticky';
            thColunas.style.top = (59 + commandLine.offsetHeight) + 'px';
            thColunas.style.zIndex = 1;
        },
        closeModal() {
            this.consultarComScroll();
        },
        abrirModalExtrato(item) {
            this.$refs['extratoHonorariosProtesto'].abrirExtrato({
                id: item.codRequisicaoProtesto,
                tabelaOrigem: 3,
                numeroRequisicao: item.numeroRequisicao
            });
        },
        obterHonorariosProtesto(id, avancarDois) {
            this.$emit('obterHonorariosProtesto', id, avancarDois);
        },
        abrirModalExtratoCda(numeroCda) {
          this.$emit('abrirExtratoCda', numeroCda);
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();

        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
